import { documentRef } from "./xhr-hook-window";

export const UPLOAD_EVENTS = ["load", "loadend", "loadstart"];
export const COMMON_EVENTS = ["progress", "abort", "error", "timeout"];

const depricatedProp = (p: any) =>
  ["returnValue", "totalSize", "position"].includes(p);

export const mergeObjects = function (src: any, dst: any) {
  for (let k in src) {
    if (depricatedProp(k)) {
      continue;
    }
    const v = src[k];
    try {
      dst[k] = v;
    } catch (error) {}
  }
  return dst;
};

//proxy events from one emitter to another
export const proxyEvents = function (events: any, src: any, dst: any) {
  const p = (event: any) =>
    function (e: any) {
      const clone: any = {};
      //copies event, with dst emitter inplace of src
      for (let k in e) {
        if (depricatedProp(k)) {
          continue;
        }
        const val = e[k];
        clone[k] = val === src ? dst : val;
      }
      //emits out the dst
      return dst.dispatchEvent(event, clone);
    };
  //dont proxy manual events
  for (let event of Array.from(events)) {
    if (dst._has(event)) {
      src[`on${event}`] = p(event);
    }
  }
};

//create fake event
export const fakeEvent = function (type: any) {
  if (documentRef && (<any>documentRef).createEventObject != null) {
    const msieEventObject = (<any>documentRef).createEventObject();
    msieEventObject.type = type;
    return msieEventObject;
  }
  // on some platforms like android 4.1.2 and safari on windows, it appears
  // that new Event is not allowed
  try {
    return new Event(type);
  } catch (error) {
    return { type };
  }
};
